
import Slider from "react-slick";
export default function ListSlider({ technologies }) {
    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/> </svg>
            </div>
        );
    }
    
    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/> </svg>
            </div>
        );
    }
    const settings = {
        dots: false,
        infinite: true,
        arrows: true,
        centerPadding: "60px",
        speed: 500,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              }
            }
        ]
    };  
	return (
		<>
            <div class="kitbug-post-slider-area design-one kitbug-retechno-slider-area arrow-design-two">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="kitbug-items-slider-area design-four arrow-design-two">
                                {technologies == null ? 'loading..' : 
                                    <Slider  {...settings}>
                                        {
                                            technologies.map(
                                                ({title, meta_box, link}, index) => {
                                                    const {templateburg_grid_img } = meta_box
                                                    return(
                                                        <div class="col-md-4">
                                                            <a href={link} class="kitbug-technologies-single design-one">
                                                                {templateburg_grid_img != null && templateburg_grid_img.length > 0 && 
                                                                    <div class="kitbug-technologies-single-img">
                                                                        <img
                                                                            src={templateburg_grid_img[0].full_url}
                                                                            alt={title.raw ? title.raw : 'author'}
                                                                        />
                                                                    </div>
                                                                }
                                                                <p>{title.raw}</p>
                                                            </a>
                                                        </div>
                                                    )
                                                }
                                            )
                                        }
                                    </Slider>
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </div>
		</>
	);
}
